const streamPreviewStyles = {
    container: {
        position: "absolute",
        left: "-32px",
        top: "5px",
        "& svg": {
            width: "24px",
            height: "24px",
            fill: "none"
        }
    }
};

export default streamPreviewStyles;
